import { _defineProperty } from "./index13.js";
import { RunPipeline } from "./index182.js";
import { CompressRgObject } from "./index197.js";
import { DecompressRgObjectDto } from "./index199.js";
import { AggManagerBase } from "./index237.js";
import { cloneRgObject } from "@project-rouge/rg-core";
var AggManager = class extends AggManagerBase {
	constructor(..._args) {
		super(..._args);
		_defineProperty(this, "type", "sync");
	}
	async compressRgObject(obj) {
		return CompressRgObject(obj);
	}
	async decompressRgObjectDto(data) {
		return DecompressRgObjectDto(data);
	}
	async generate(obj, aggProps, briefIndex) {
		const pipeResult = RunPipeline({
			obj: cloneRgObject(obj),
			aggProps,
			briefIndex,
			cache: this.cache
		});
		return {
			result: pipeResult.obj,
			meta: pipeResult.meta
		};
	}
};
export { AggManager };

//# sourceMappingURL=index238.js.map